import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { WEBApi } from '../API/WEBApi';
import styles from './BlogView.module.css';
import { FaLongArrowAltRight } from 'react-icons/fa';
import Home_7 from '../Home/Home_7';

interface Blog {
    _id: string;
    title: string;
    author: string;
    slug: string;
    date: string;
    content: string;
    image: string;
    blob: string;
}

const BlogView: React.FC = () => {
    const { slug } = useParams<{ slug: string }>();
    const [blog, setBlog] = useState<Blog | null>(null);
    const [relatedBlogs, setRelatedBlogs] = useState<Blog[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (!slug) {
            navigate('/blogs');
            return;
        }

        const fetchBlog = async () => {
            try {
                setIsLoading(true);
                const res = await WEBApi.getBlogBySlug(slug); // expecting { blog, randomBlogs }
                setBlog(res.blog);
                setRelatedBlogs(res.randomBlogs);
            } catch (error) {
                console.error('Error fetching blog:', error);
                navigate('/blogs');
            } finally {
                setIsLoading(false);
            }
        };

        fetchBlog();
    }, [slug, navigate]);

    return (
        <>
            <main className={`container ${styles.blogView} page-top-margin`}>
                {isLoading ? (
                    <div className={styles.fixHeight}>
                        <h1 className={styles.title}>
                            <div className={styles['slot-loading']}>
                                <p className="card-text placeholder-wave">
                                    <span className="placeholder col-12"></span>
                                </p>
                            </div>
                        </h1>
                        <div className={styles.content}>
                            {[...Array(2)].map((_, i) => (
                                <div key={i} className={styles['slot-loading']}>
                                    <p className="card-text placeholder-wave">
                                        <span className="placeholder col-12"></span>
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    blog && (
                        <>
                            <h1 className={styles.title}>{blog.title}</h1>
                           

                            <hr className={styles['top-splitter']} />


                            <div className={styles.breadcrumbs}>
                                <Link to="/blogs">Blogs</Link>{' '}
                                <FaLongArrowAltRight /> {blog.title}
                            </div>
                            <div className={styles.meta}>
                                <div>By {blog.author}</div>
                            </div>

                            <div className={styles['data-container']}>
                                <div className={styles['left-data']}>
                                    <div className={styles['image-container']}>
                                        <img src={blog.image} alt={blog.title} />
                                        {blog.blob && <div className={styles['blob']}>{blog.blob} </div>}
                                       
                                    </div>

                                    <div
                                        className={styles.content}
                                        dangerouslySetInnerHTML={{
                                            __html: blog.content,
                                        }}
                                    />
                                </div>

                                <div className={styles['right-data']}>
                                    <h3 className={styles['related-title']}>Related Blogs</h3>
                                    {relatedBlogs.map((b) => (
                                        <div key={b._id} className={styles['related-blog']}>
                                            <Link to={`/blogs/${b.slug}`}>
                                                <img src={b.image} alt={b.title} className={styles['related-img']} />
                                                <p className={styles['related-title-text']}>{b.title}</p>
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )
                )}
            </main>
            <Home_7 background="#fff" />
        </>
    );
};

export default BlogView;
